module.exports = __webpack_public_path__ + "static/media/36.68cda92d.png";